
const DetectiveBackground = () => {
  return (
    <div className="absolute inset-0 detective-board">
      <div className="absolute inset-0 opacity-5">
        <div 
          className="w-full h-full"
          style={{
            backgroundImage: "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
            backgroundSize: "20px 20px"
          }}
        ></div>
      </div>
      
      {/* Subtle grid lines for detective board effect */}
      <div className="absolute inset-0 opacity-5">
        <div className="w-full h-full" style={{
          backgroundImage: "radial-gradient(rgba(255, 255, 255, 0.15) 1px, transparent 1px)",
          backgroundSize: "30px 30px"
        }}></div>
      </div>
    </div>
  );
};

export default DetectiveBackground;
